import {
	LOADING
} from '../actions/types';

const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case LOADING:
			return action.payload;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/LoadingReducer.js